import React from 'react';

import Icon from '../static/j-made_logo.png';

const Logo: React.FC = () => <img height={200} width={200} src={Icon} alt="アイコン" />;

export default Logo;
